<template>
    <select class="chosen" :data-placeholder="placeholder" :multiple="multiple">
        <template v-if="!hasGroups">
            <option v-for="option in options" v-bind:value="option.id">
                {{ option.label }}
            </option>
        </template>
        <template v-if="hasGroups">
            <optgroup v-for="(group, label) in options" v-bind:label="label">
                <option v-for="option in group" v-bind:value="option.id">
                    {{ option.label }}
                </option>
            </optgroup>
        </template>
    </select>
</template>

<script>
    export default {
        props: {
            value: {
                type: [String, Number, Array, Object],
                default: null
            },
            options: {
                type: [Array, Object],
                default: []
            },
            multiple: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select'
            },
            searchable: {
                type: Boolean,
                default: true
            },
            searchableMin: {
                type: Number,
                default: 1
            },
            allowEmpty: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            hasGroups () {
                return !Array.isArray(this.options)
            },
            localValue () {
                this.$nextTick(function () {
                    $(this.$el).val(this.value).trigger('chosen:updated')
                })
                return this.value
            }
        },
        watch: {
            localValue () {
            }
        },
        mounted () {
            let component = this
            $(this.$el).chosen({
                width: '100%',
                disable_search_threshold: this.searchable ? this.searchableMin : 100000
            }).change(function ($event) {
                component.$emit('input', $($event.target).val())
            })
        }
    }
</script>



// WEBPACK FOOTER //
// VueChosen.vue?3eb2d5d4